import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import GlobePage from '@/features/globe/GlobePage'

/**
 * Canonical Phenom-Event share link target (#388 / dev-nest #9):
 * `/globe?event=<id>` opens the event in Globe View — GlobePage selects the
 * event and recreates its captured camera on load. `strict: false` consumers
 * elsewhere read the same `event` key.
 */
const globeSearchSchema = z.object({
  event: z.string().optional(),
  // ADS-B mode hint carried by share links (#388): `historical` arms the
  // Historical selector once the deep-linked event is selected. GlobePage reads
  // it; absent/invalid → the globe's own default (realtime).
  adsb: z.enum(['realtime', 'historical']).optional(),
})

export const Route = createFileRoute('/_authenticated/globe/')({
  component: GlobePage,
  validateSearch: globeSearchSchema,
})
